import { HubToHubMapper } from "@/data/persistences/mappers/HubToHubMapper";
import { HubToHubEndpoints } from "../../endpoints/HubToHubEndpoint";
import ApiService from "../../services/ApiService";
import { HubToHubRepositoryInterface } from "@/data/persistences/repositories/contracts/HubToHubRepositoryInterface";
import { InHubScanGenerateList, InHubScanTemporaryListRequest, HubInOutManifestEntities, HubInOutManifestRequest, ResponsePayload, HubInOutManifestExcelRequest, HubInOutManifestExcel, HubManifestTemporaryList } from "@/domain/entities/HubToHub";
import { GenerateInHubScanRequest, AddProsesManifest } from "@/data/payload/api/HubToHubApiRequest";
import { postManifestRequestInterface } from "@/data/payload/contracts/HubToHubRequest";
import { downloadFile } from "@/app/infrastructures/misc/Utils";
import { Endpoints } from "@/app/infrastructures/misc/Endpoints";

export class HubToHubApiRepository implements HubToHubRepositoryInterface {
  private service: ApiService;
  private mapper: HubToHubMapper;
  private endpoints: HubToHubEndpoints;

  constructor(
    service: ApiService,
    mapper: HubToHubMapper,
    endpoints: HubToHubEndpoints
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async generateInHubScan(
    payload: GenerateInHubScanRequest
  ): Promise<InHubScanGenerateList> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.generateInHubScan(),
      undefined,
      payload
    );

    return this.mapper.convertGenerateInHubScanFromApi(resp);
  }

  async getListHubManifestTemporary(
    params: InHubScanTemporaryListRequest
  ): Promise<HubManifestTemporaryList> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getListHubManifestTemporary(params),
      undefined
    );

    return this.mapper.convertGetListHubManifestTemporaryFromApi(resp);
  }

  public async processHubManifest(payload: postManifestRequestInterface): Promise<ResponsePayload> {
    const resp = await this.service.invoke("post", this.endpoints.processHubManifest(), undefined, payload as AddProsesManifest);
    return this.mapper.convertPayloadProsesManifest(resp);
  }
  async getHubManifestDetail(id: number) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getHubManifestDetail(id)
    );

    return this.mapper.convertHubManifestDetail(res);
  }
  
  async getHubInOutManifestList(
    params: HubInOutManifestRequest
  ): Promise<HubInOutManifestEntities> {
    const resp = await this.service.invoke(
      "GET",
      this.endpoints.getHubInOutManifestList(params),
      undefined
    );

    return this.mapper.convertGetHubInOutManifestListFromApi(resp);
  }

  public async getHubManifestExcel(
    params: HubInOutManifestExcelRequest
  ): Promise<HubInOutManifestExcel> {
    return downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.getHubManifestExcel(params)}`,
      `${params.type} - ${params.id}`,
      ".xlsx",
      true
    );
    
  }
}
